<template>
  <div class="mainBody">
    <div class="mainCtn">
      <div class="label">
        <img src="../../assets/rsTool/任务创建人图标.png" height="20" width="20" style="display: inline-block;margin-right: 1px;margin-top: -3px;" />
        我是外业核查人员
      </div>
      <div class="txtTitle" style="margin-top: 80px;">
        请使用手机浏览器扫描下方二维码
      </div>
      <div class="txtTitle" style="margin-top: 10px;">
        下载吉林一号·核查助手APP
      </div>
      <div class="middleCtn">
        <div style="width: 200px;height: 200px;margin-right: 80px;">
          <img src="~@/assets/newHome/安卓二维码.png" height="200" width="200" />
        </div>
        <div style="width: 200px;height: 200px;">
          <img src="~@/assets/newHome/ios二维码.png" height="200" width="200" />
        </div>
      </div>
      <div @click="$router.push('/fieldWorkEnter')" class="button">
        确定
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'wyMobileDownload',
  data() {
    return {}
  },
  methods: {},
  mounted() {

  }
}

</script>
<style scoped lang="scss">
.mainBody{
  width: 100%;
  height:100%;
  //background-image: url('../../assets/rsTool/选角色背景.png');
  background: #efefef;
  background-size: 100% 100%;
  padding-top: 1px;
}
.mainCtn{
  width: 100%;
  height: calc(100% - 100px);
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
  background: #ffffff;
  .label{
    width: 208px;
    height: 40px;
    background: rgba(0,102,204,0.35);
    border-radius: 4px;
    line-height: 40px;
    font-size: 21px;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #0066CC;
    padding-left: 6px;
  }
  .txtTitle{
    width: 100%;
    height:30px;
    line-height: 30px;
    text-align: center;
    font-size: 21px;
    font-weight: 600;
    color:#000000;
  }
  .middleCtn{
    margin-top: 30px;
    width: 100%;
    height:200px;
    display: flex;
    justify-content: center;
  }
  .button{
    background: #0066CC;
    color:#ffffff;
    width: 100px;
    height:35px;
    line-height: 35px;
    text-align: center;
    border-radius: 5px;
    margin-top: 30px;
    cursor:pointer;
  }
}
</style>